import React from 'react';
import { Row, Col } from 'react-bootstrap';

function PageTitle({
  pageName,
  actionButton
}) {
  return (
    <>
      <Row>
        <Col xs={10} sm={10} md={10} lg={10} xl={10}>
          <h5 className="page-title">{pageName}</h5>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}>
          <div className="button-float-right">
            { actionButton ? actionButton : "" }
          </div>
        </Col>
      </Row>
    </>
  )
}

export default PageTitle
